"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationSpiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function notificationSpiClient(networkClient) {
    return {
        sendNotificationMessage: (message) => {
            networkClient.fireToTopic(data_lib_1.SEND_NOTIFICATION_MESSAGE_TOPIC, message, "Unable to send notification message, error=%s");
        },
        createNotification: (body) => {
            return networkClient.postHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/spi/v2/accounts/notifications/messages`, body);
        },
    };
}
exports.notificationSpiClient = notificationSpiClient;
